import { useGetInstitutionQuery } from '@metadevprofile/shared/api';
import { useEffect } from 'react';
import { getEdenErrorMessage } from '@/common/lib/get-eden-error';
import { notificationService } from '@/common/lib/notification-service';

export function useInstitution(options?: { skip?: boolean }) {
  const { data, isLoading, error } = useGetInstitutionQuery(undefined, { skip: options?.skip });

  useEffect(() => {
    if (error) {
      notificationService.error(getEdenErrorMessage(error, 'institution:errors.loadInstitutionFailed'));
    }
  }, [error]);

  return { institution: data ?? null, loading: isLoading };
}
